module.exports = __webpack_public_path__ + "76c070206aa30ed76ed1093de8631ebf.svg";